import React from 'react';
import './BlockedBySalesNameCheck.css';

/**
 * Shown instead of an empty page when the server refuses a page with
 * 409 SALES_NAME_CHECK_IN_PROGRESS (spec §10.2, §10.4): while a business is
 * onboarding, an in-progress Sales Name Check blocks Ingredient
 * Reconciliation, opening stock and Closing Stock until it is finished or
 * set aside.
 */
export const SALES_NAME_CHECK_BLOCK_CODE = 'SALES_NAME_CHECK_IN_PROGRESS';

/** True for an httpClient error (error.status / error.data) carrying the gate's 409. */
export const isSalesNameCheckBlock = (error) => Boolean(
  error && error.status === 409 && error.data && error.data.code === SALES_NAME_CHECK_BLOCK_CODE,
);

export default function BlockedBySalesNameCheck({ onOpen }) {
  return (
    <div className="sncb-panel" role="alert">
      <h2 className="sncb-title">This page is waiting for Sales Name Check</h2>
      <p className="sncb-text">Sales Name Check is in progress — finish it or set it aside first.</p>
      {onOpen && (
        <button type="button" className="sncb-btn" onClick={onOpen}>
          Open Sales Name Check
        </button>
      )}
    </div>
  );
}
